import React, { ReactNode } from 'react';
import Cookies from 'js-cookie';

interface IsLoggedInProps {
    cookieName: string;
    children: {
      exist: ReactNode;
      notExist?: ReactNode;
    };
  }

  const IsLoggedIn: React.FC<IsLoggedInProps> = ({ cookieName, children }) => {
    const cookieExists = Boolean(Cookies.get(cookieName));

    return cookieExists ? children.exist : children.notExist || <></>;
};

export default IsLoggedIn;
